import React, { useEffect } from "react";

const Sell = () => {
    useEffect(() => {
        window.location.href = "https://www.youtube-nocookie.com/embed/Rb0i6JIUIfA?playlist=Rb0i6JIUIfA&autoplay=1&iv_load_policy=3&loop=1&start=";
    }, []);

    return null;
};

export default Sell;